"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPassRules = void 0;

function checkPassRules(pwd) {
  var small = /[a-z]/.test(pwd);
  var upper = /[A-Z]/.test(pwd);
  var digit = /[\d]/.test(pwd);
  var other = /[\W]/.test(pwd);
  var length = pwd.length >= 8;
  return {
    small: small,
    upper: upper,
    digit: digit,
    other: other,
    length: length
  };
}

exports.checkPassRules = checkPassRules;